// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.grid_Vo3TC {
  display : grid;
  position : absolute;
  top : 0;
  left : 0;
  right : 0;
  bottom : 0;
  grid-template-areas: var( --grid );
  grid-template-columns: auto 1fr 1fr auto;
  grid-template-rows: auto 1fr 1fr auto;
  height: 100%;
}

.main_jPvRA {
  position : relative;
  grid-area : main;
}

.aux1_ve6aH {
  position : relative;
  grid-area : aux1;
  overflow-x: auto;
  overflow-y: hidden;
}

.aux2_r4AYs {
  position : relative;
  grid-area : aux2;
  overflow-x: auto;
  overflow-y: hidden;
}

.aux3_HV36G {
  position : relative;
  grid-area : aux3;
  overflow-x: hidden;
  overflow-y: auto;
}

.aux4_g5r4W {
  position : relative;
  grid-area : aux4;
  overflow-x: hidden;
  overflow-y: auto;
}

.hiddenDataViewers_BMwam {
  display: none;
}
`, "",{"version":3,"sources":["webpack://./../../node_modules/@leverege/molten/lib/screens/itemInfo/DesktopItemInfoScreen.css"],"names":[],"mappings":";AACA;EACE,cAAc;EACd,mBAAmB;EACnB,OAAO;EACP,QAAQ;EACR,SAAS;EACT,UAAU;EACV,kCAAkC;EAClC,wCAAwC;EACxC,qCAAqC;EACrC,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf","sourcesContent":["\n.grid {\n  display : grid;\n  position : absolute;\n  top : 0;\n  left : 0;\n  right : 0;\n  bottom : 0;\n  grid-template-areas: var( --grid );\n  grid-template-columns: auto 1fr 1fr auto;\n  grid-template-rows: auto 1fr 1fr auto;\n  height: 100%;\n}\n\n.main {\n  position : relative;\n  grid-area : main;\n}\n\n.aux1 {\n  position : relative;\n  grid-area : aux1;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.aux2 {\n  position : relative;\n  grid-area : aux2;\n  overflow-x: auto;\n  overflow-y: hidden;\n}\n\n.aux3 {\n  position : relative;\n  grid-area : aux3;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.aux4 {\n  position : relative;\n  grid-area : aux4;\n  overflow-x: hidden;\n  overflow-y: auto;\n}\n\n.hiddenDataViewers {\n  display: none;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"grid": `grid_Vo3TC`,
	"main": `main_jPvRA`,
	"aux1": `aux1_ve6aH`,
	"aux2": `aux2_r4AYs`,
	"aux3": `aux3_HV36G`,
	"aux4": `aux4_g5r4W`,
	"hiddenDataViewers": `hiddenDataViewers_BMwam`
};
export default ___CSS_LOADER_EXPORT___;
